/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMyHomeV3CreateRealtyRequest,
  TPublicMyHomeV3CreateRealtyModel,
  IMappers,
  TPublicMyHomeV3CreateRealtyResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ICreateSecondaryMyHomeV3Response } from '../../../entities/web/CreateSecondaryMyHomeV3Response';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMyHomeV3CreateRealtyModel(
  parameters: TPublicMyHomeV3CreateRealtyRequest,
): TPublicMyHomeV3CreateRealtyModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/my-home/v3/create-realty/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMyHomeV3CreateRealtyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMyHomeV3CreateRealtyRequest;
}

export async function fetchPublicMyHomeV3CreateRealty<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV3CreateRealtyOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMyHomeV3CreateRealtyResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMyHomeV3CreateRealtyModel(parameters),
    config,
  )) as FetchResponse<TPublicMyHomeV3CreateRealtyResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateSecondaryMyHomeV3Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMyHomeV3CreateRealtyResponse>;
}
